import React, { Component } from 'react';
import styled from 'styled-components';
import { connectHits, CurrentRefinements } from 'react-instantsearch-dom';
import { withTranslation } from 'react-i18next';


import FilterPanel from './FilterPanel';
import ProjectHitsPanel from './ProjectHitsPanel';
import FilterIcon from './filterIcon.svg';

import CurrentRefinementList from './CurrentRefinementList';

const ToggleButton = styled.div`
  width: 98.4px;
  height: 44.1px;
  padding: 12px 5px 12px 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.27);
  background-color: #e7b940;
  position: absolute;
  z-index: 999;
  left: calc(68% - 98.4px);
  cursor: pointer;
  font-family: Open Sans, sans-serif;;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: left;
  color: #2c271c;
`;

const mapResultStyle = {
  background: '#fff',
  position: 'relative',
  maxHeight:'100vh',
  overflow:'auto',
}

class ProjectSidePanel extends Component {

  constructor(props) {
    super(props);
    this.state = {
      toggleLabel: 'Filters',
      filterPanelVisible: true
    };
  }

  onToggle = () =>
    this.setState(({ filterPanelVisible }) => ({
      filterPanelVisible: !filterPanelVisible,
    }));

  render() {

    const filterPanelVisible = this.state.filterPanelVisible;


    return (
      <React.Fragment>
      <ToggleButton onClick={this.onToggle}>{!filterPanelVisible && <img src={FilterIcon} style={{paddingRight: '9px'}}/> }{filterPanelVisible ? this.props.t('Filter.Hide') : this.props.t('Filter.Show')}</ToggleButton>
      <div className="map__results-inner" style={mapResultStyle}>
        <div className={filterPanelVisible ? 'panel-block' : 'panel-hidden'}>
          <FilterPanel />
        </div>
        <div className={filterPanelVisible ? 'panel-hidden' : 'panel-block'}>
            <CurrentRefinementList />
          <ProjectHitsPanel />
        </div>
      </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(ProjectSidePanel);
